import { jsx as _ } from "react/jsx-runtime";
import { a as d } from "../../core-DVmjA3_O.js";
import { _ as m } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import '../../index22.css';const h = "_description_19vof_1", S = "_with-centered-content_19vof_9", f = "_with-content-max-width_19vof_15", v = "_text-size-extra-small_19vof_19", V = "_text-size-small_19vof_23", z = "_text-size-medium_19vof_27", w = "_text-size-large_19vof_31", g = "_color-variant-text_19vof_35", p = "_color-variant-text-on-dark_19vof_39", C = "_color-variant-primary_19vof_43", u = "_color-variant-secondary_19vof_47", y = "_color-variant-success_19vof_51", T = "_color-variant-danger_19vof_55", D = "_with-light-text_19vof_59", t = {
  description: h,
  withCenteredContent: S,
  withContentMaxWidth: f,
  textSizeExtraSmall: v,
  textSizeSmall: V,
  textSizeMedium: z,
  textSizeLarge: w,
  colorVariantText: g,
  colorVariantTextOnDark: p,
  colorVariantPrimary: C,
  colorVariantSecondary: u,
  colorVariantSuccess: y,
  colorVariantDanger: T,
  withLightText: D
}, L = {
  text: t.colorVariantText,
  primary: t.colorVariantPrimary,
  secondary: t.colorVariantSecondary,
  success: t.colorVariantSuccess,
  danger: t.colorVariantDanger,
  "text-on-dark": t.colorVariantTextOnDark
};
function E(r) {
  const {
    className: a,
    children: i,
    withCenteredContent: n,
    elementRef: c,
    textSize: e = "md",
    withLightText: s,
    colorVariant: o,
    withContentMaxWidth: l,
    ...x
  } = r;
  return /* @__PURE__ */ _(
    "div",
    {
      ...x,
      ref: c,
      className: m(
        t.description,
        n && t.withCenteredContent,
        e === "xs" && t.textSizeExtraSmall,
        e === "sm" && t.textSizeSmall,
        e === "md" && t.textSizeMedium,
        e === "lg" && t.textSizeLarge,
        d(o) && L[o],
        s && t.withLightText,
        l && t.withContentMaxWidth,
        a
      ),
      children: i
    }
  );
}
export {
  E as default
};
